import React, { PureComponent } from 'react';
import { compose } from 'recompose';
import PropTypes from 'prop-types';
import { ContentFilterUI } from './ui';

export class ContentFilter extends PureComponent {
    static displayName = 'ContentFilterContainer';

    static propTypes = {
        onChange: PropTypes.func,
        name: PropTypes.string,
        value: PropTypes.shape({
            type: PropTypes.string,
            operator: PropTypes.string,
            value: PropTypes.any
        })
    };

    static defaultProps = {
        onChange: undefined,
        name: 'contentFilter',
        value: null
    };

    render() {
        const { name, value, onChange } = this.props;
        return <ContentFilterUI value={value} onChange={onChange} name={name} />;
    }
}

export const ContentFilterContainer = compose()(ContentFilter);
